<template>
    <transition name="modal" appear>
        <div class="modal" role="dialog" aria-modal="true" aria-labelledby="podcast-modal-title">
            <header class="modal-header">              
                <div class="title">
                    <img :src="require('@/assets/images/website/zappelin-logo.png')" alt="Zappelin logo" />
                    <h1 id="podcast-modal-title">De Boterhamshow podcast</h1>
                </div> 
                <button class="close-button" aria-label="Sluiten" @click="closeModal">
                    <svg aria-hidden="true" height="24px" id="Layer_1" style="enable-background:new 0 0 512 512;" version="1.1" viewBox="0 0 512 512" width="24px" xml:space="preserve" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink"><path d="M437.5,386.6L306.9,256l130.6-130.6c14.1-14.1,14.1-36.8,0-50.9c-14.1-14.1-36.8-14.1-50.9,0L256,205.1L125.4,74.5  c-14.1-14.1-36.8-14.1-50.9,0c-14.1,14.1-14.1,36.8,0,50.9L205.1,256L74.5,386.6c-14.1,14.1-14.1,36.8,0,50.9  c14.1,14.1,36.8,14.1,50.9,0L256,306.9l130.6,130.6c14.1,14.1,36.8,14.1,50.9,0C451.5,423.4,451.5,400.6,437.5,386.6z"/></svg>
                </button>
            </header>
            <div class="modal-body">
                <div
                    v-for="(episode, index) in podcasts"
                    :key="episode.id"
                    class="podcast-episode"
                >
                    <h2>{{ episode.title }}</h2>
                    <p class="podcast-episode__description">{{ episode.description }}</p>
                    <div class="podcast-player">
                        <audio
                            ref="audioPlayers"
                            preload="none"
                            @timeupdate="onTimeUpdate(index)"
                            @ended="onEnded(index)"
                        ></audio>
                        <button
                            class="podcast-player__btn"
                            :aria-label="playerState[index] && playerState[index].playing ? 'Pauzeer ' + episode.title : 'Speel ' + episode.title"
                            @click="togglePlay(index, episode.url)"
                        >
                            <svg v-if="!playerState[index] || !playerState[index].playing" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24"><path d="M8 5v14l11-7z"/></svg>
                            <svg v-else xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24"><path d="M6 19h4V5H6v14zm8-14v14h4V5h-4z"/></svg>
                        </button>
                        <input
                            type="range"
                            class="podcast-player__progress"
                            :value="playerState[index] ? playerState[index].currentTime : 0"
                            :max="parseDuration(episode.duration)"
                            step="1"
                            :aria-label="'Voortgang ' + episode.title"
                            @input="onScrub(index, $event)"
                        />
                        <span class="podcast-player__time" aria-live="off">
                            {{ playerState[index] ? formatTime(playerState[index].currentTime) : '0:00' }}/{{ formatDuration(episode.duration) }}
                        </span>
                    </div>
                </div>
            </div>
        </div>
    </transition>
</template>

<script>
    import { mapGetters, mapActions } from 'vuex'
    import { focusTrap } from '@/mixins/focusTrap'
    import { lockScroll, unlockScroll } from '@/utils/scrollLock'

	export default {
        mixins: [focusTrap],
        data () {
            return {
                playerState: []
            }
        },

        watch: {
            podcasts (episodes) {
                episodes.forEach(function (_, i) {
                    this.$set(this.playerState, i, { playing: false, currentTime: 0, loaded: false })
                }, this)
            }
        },

        mounted () {
            smarttag && smarttag('podcast')
            lockScroll()
            this.getPodcasts()
        },

        beforeDestroy () {
            this.$refs.audioPlayers && this.$refs.audioPlayers.forEach(function (player) {
                player.pause()
            })
            unlockScroll()
        },

        computed: {
            ...mapGetters([
                'podcasts'
            ])
        },

 		methods: {
            ...mapActions([
                'getPodcasts'
            ]),

            togglePlay (index, url) {
                var player = this.$refs.audioPlayers[index]
                var state = this.playerState[index]

                if (!state.loaded) {
                    player.src = url
                    this.$set(this.playerState, index, Object.assign({}, state, { loaded: true }))
                    state = this.playerState[index]
                }

                // pause all other players
                this.$refs.audioPlayers.forEach(function (p, i) {
                    if (i !== index && !p.paused) {
                        p.pause()
                        this.$set(this.playerState, i, Object.assign({}, this.playerState[i], { playing: false }))
                    }
                }, this)

                if (player.paused) {
                    player.play()
                    this.$set(this.playerState, index, Object.assign({}, state, { playing: true }))
                } else {
                    player.pause()
                    this.$set(this.playerState, index, Object.assign({}, state, { playing: false }))
                }
            },

            onTimeUpdate (index) {
                var player = this.$refs.audioPlayers[index]
                this.$set(this.playerState, index, Object.assign({}, this.playerState[index], { currentTime: player.currentTime }))
            },

            onEnded (index) {
                this.$set(this.playerState, index, Object.assign({}, this.playerState[index], { playing: false, currentTime: 0 }))
            },

            formatTime (seconds) {
                var s = Math.floor(seconds || 0)
                var m = Math.floor(s / 60)
                var ss = s % 60
                return m + ':' + (ss < 10 ? '0' : '') + ss
            },

            formatDuration (duration) {
                return duration.replace(/^00:/, '')
            },

            parseDuration (duration) {
                var parts = duration.split(':').map(Number)
                return parts[0] * 3600 + parts[1] * 60 + parts[2]
            },

            onScrub (index, event) {
                var player = this.$refs.audioPlayers[index]
                var time = Number(event.target.value)
                player.currentTime = time
                this.$set(this.playerState, index, Object.assign({}, this.playerState[index], { currentTime: time }))
            },

             closeModal () {
                 this.$router.push('/')
             }
 		}

 	}

 </script>

<style lang="scss" scoped>

.modal {
    position: fixed;
    left: 50%;
    top: 50%;
    margin-left: -35%;
    width: 70%;
    height: auto;
    max-height: 80vh;
    overflow-y: auto;
    z-index: 3002;
    background-color: #a82134;
    transform: translateY(-50%);
    border-radius: 6px;
}

h1, h2 {
    font-family: 'bariol-bold';
    font-weight: normal;
}

h1 {
    font-size: 32px;
    margin: 0 0 0 10px;
    line-height: 0;
}

h2 {
    font-size: 22px;
    font-weight: bold;
    color: white;
    margin: 0 0 10px 0;
}

.modal-header {
    border-radius: 6px 6px 0px 0px;
    display: flex;
    background: white;
    padding: 20px;
    justify-content: space-between;
    align-items: center;
    position: sticky;
    top: 0;
    z-index: 1;
}

.title {
    display: flex;
    align-items: center;
    img {
        width: 100px;
        height: auto;
        margin-right: 15px;
    }
}

.close-button {
    background: none;
    border: 0;
    outline: 0;
    cursor: pointer;
    padding: 20px 0 20px 10px;
    margin: 0;

    &:focus-visible {
        outline: 3px solid #a82134;
        outline-offset: 2px;
        border-radius: 4px;
    }
}

.modal-body {
    padding: 10px 20px 20px 20px;
}

.podcast-episode {
    padding: 20px 0;
    border-bottom: 1px solid rgba(255, 255, 255, 0.2);

    &:last-child {
        border-bottom: none;
    }
}

.podcast-player {
    display: flex;
    align-items: center;

    audio {
        display: none;
    }
}

.podcast-player__btn {
    background: white;
    border: 0;
    outline: 0;
    cursor: pointer;
    border-radius: 50%;
    width: 44px;
    height: 44px;
    display: flex;
    align-items: center;
    justify-content: center;
    flex-shrink: 0;
    -webkit-box-shadow: 0 6px 1px rgba(5, 21, 34, 0.29);
    box-shadow: 0 6px 1px rgba(5, 21, 34, 0.29);
    transition: transform .15s ease;

    &:hover {
        transform: scale(1.08);
    }

    &:focus-visible {
        outline: 3px solid white;
        outline-offset: 3px;
    }

    svg {
        width: 24px;
        height: 24px;
        fill: #a82134;
        display: block;
    }
}

.podcast-episode__description {
    font-family: 'bariol-regular';
    font-size: 16px;
    color: #ffffff;
    line-height: 1.5;
    margin: 0 0 14px 0;
}

.podcast-player__progress {
    flex: 1;
    margin: 0 14px;
    -webkit-appearance: none;
    appearance: none;
    height: 4px;
    border-radius: 2px;
    background: rgba(255, 255, 255, 0.85);
    cursor: pointer;
    outline: none;

    &:focus-visible {
        outline: 3px solid white;
        outline-offset: 4px;
        border-radius: 2px;
    }

    &::-webkit-slider-thumb {
        -webkit-appearance: none;
        appearance: none;
        width: 16px;
        height: 16px;
        border-radius: 50%;
        background: white;
        cursor: pointer;
        box-shadow: 0 2px 4px rgba(0, 0, 0, 0.2);
    }

    &::-moz-range-thumb {
        width: 16px;
        height: 16px;
        border-radius: 50%;
        background: white;
        cursor: pointer;
        border: none;
        box-shadow: 0 2px 4px rgba(0, 0, 0, 0.2);
    }

    &::-moz-range-track {
        background: rgba(255, 255, 255, 0.3);
        height: 4px;
        border-radius: 2px;
    }
}

.podcast-player__time {
    font-family: 'bariol-bold';
    font-size: 18px;
    color: white;
    white-space: nowrap;
}

.modal-enter-active, .modal-leave-active {
  transition: opacity .3s, transform .5s;
}
.modal-enter, .modal-leave-to {
  opacity: 0;
  transform: translateY(100px);
}
</style>



// WEBPACK FOOTER //
// PodcastModal.vue?554d7330